module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browserListTip":"Use one of the browsers listed below:","back":"Go back","profile":"personal data","cameraOn":"permissions","micSettings":"mic setup","cameraSettings":"camera setup","interview":"interview","email":"email","interviewRecord":"Record interview","pageTitle":"Video interview for the job","close":"Complete the video interview"}}')
  delete Component.options._Ctor
}
